import React, { useState } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';
import ShareAssetToClientsSheet, { type ShareEmailAsset } from './ShareAssetToClientsSheet';

interface ShareAssetButtonProps {
  asset: ShareEmailAsset;
  /** When false, renders nothing (admin gate). */
  visible?: boolean;
}

/**
 * Share control for EDM / eBook / report cards. Opens "Send to my clients".
 */
export default function ShareAssetButton({ asset, visible = true }: ShareAssetButtonProps) {
  const [sheetOpen, setSheetOpen] = useState(false);

  if (!visible || !asset.id) return null;

  return (
    <>
      <Tooltip title="Send to my clients" arrow placement="left">
        <span>
          <IconButton
            size="small"
            aria-label="Send to my clients"
            onMouseDown={(e) => e.stopPropagation()}
            onClick={(e) => {
              e.stopPropagation();
              setSheetOpen(true);
            }}
            sx={{
              color: 'var(--color-accent)',
              p: 0.5,
              '&:hover': { bgcolor: 'var(--color-accent-soft)' },
            }}
          >
            <ShareOutlinedIcon fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>

      <ShareAssetToClientsSheet
        open={sheetOpen}
        onClose={() => setSheetOpen(false)}
        asset={asset}
      />
    </>
  );
}
